import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MobileTooltipComponent } from './mobile-tooltip.component';
import { ModalModule } from '@finder/shared/components/modal/modal.module';

@NgModule({
    imports: [
        CommonModule,
        ModalModule,
    ],
    declarations: [
        MobileTooltipComponent,
    ],
    providers: [],
    exports: [
        MobileTooltipComponent,
    ]
})
export class MobileTooltipModule {}
